import React from 'react';

import styles from './NotFoundPage.module.less';

export default function NotFoundPage() {
  return <div>Page Not found</div>;
}
